import urljoin from 'url-join';
import ky from './kyInstance';
import qs from 'qs';

import { BASE_PATH, withAuthorizationHeader } from '..';

export const maCreate = async (cisType, params) => {
  return ky.post(urljoin(BASE_PATH, 'cis', cisType, 'ma', 'create'), {
    headers: withAuthorizationHeader(),
    body: params instanceof FormData ? params : JSON.stringify(params),
  });
};

export const maUpdate = async (id, cisType, params) => {
  return ky.post(urljoin(BASE_PATH, 'cis', cisType, 'ma', 'edit', String(id)), {
    headers: withAuthorizationHeader(),
    body: params instanceof FormData ? params : JSON.stringify(params),
  });
};

export const maRemove = async (id, cisType) => {
  return ky.delete(urljoin(BASE_PATH, 'cis', cisType, 'ma', 'delete', String(id)), {
    headers: withAuthorizationHeader(),
  });
};

export const getMaCisBar = async () => {
  return ky.get(urljoin(BASE_PATH, 'cis', 'ma', 'bar'), {
    headers: withAuthorizationHeader(),
  });
};

export const getMaCisList = async (cisType, params = {}) => {
  return ky.get(urljoin(BASE_PATH, 'cis', cisType, 'ma'), {
    headers: withAuthorizationHeader(),
    searchParams: qs.stringify(params),
  });
};

export const getMaCisDetails = async (cisType, id) => {
  return ky.get(urljoin(BASE_PATH, 'cis', cisType, 'ma', String(id)), {
    headers: withAuthorizationHeader(),
  });
};

export const create = async (cisType, params) => {
  return ky.post(urljoin(BASE_PATH, 'cis', cisType, 'create'), {
    headers: withAuthorizationHeader(),
    body: params instanceof FormData ? params : JSON.stringify(params),
  });
};

export const update = async (id, cisType, params) => {
  return ky.post(urljoin(BASE_PATH, 'cis', cisType, 'edit', String(id)), {
    headers: withAuthorizationHeader(),
    body: params instanceof FormData ? params : JSON.stringify(params),
  });
};

export const remove = async (id, cisType) => {
  return ky.delete(urljoin(BASE_PATH, 'cis', cisType, 'delete', String(id)), {
    headers: withAuthorizationHeader(),
  });
};

export const getCisBar = async () => {
  return ky.get(urljoin(BASE_PATH, 'cis', 'bar'), {
    headers: withAuthorizationHeader(),
  });
};

export const getCisList = async (cisType, params = {}) => {
  return ky.get(urljoin(BASE_PATH, 'cis', cisType), {
    headers: withAuthorizationHeader(),
    searchParams: qs.stringify(params),
  });
};

export const getCisDetails = async (cisType, id) => {
  return ky.get(urljoin(BASE_PATH, 'cis', cisType, String(id)), {
    headers: withAuthorizationHeader(),
  });
};

export const getCertificateHoldersOptions = async (params, type = 'ipma') => {
  const query = Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join('&');

  let url = urljoin(BASE_PATH, 'cis', 'certificate-holders', 'options', `?${query}`);
  if (type === 'ma') {
    url = urljoin(BASE_PATH, 'cis', 'certificate-holders', 'ma', 'options', `?${query}`);
  }

  return ky.get(url, {
    headers: withAuthorizationHeader(),
  });
};

export const getOrganizationCertificationBodyLevelDomains = async (id) => {
  return ky.get(urljoin(BASE_PATH, 'cis', 'organizations', 'domains', String(id)), {
    headers: withAuthorizationHeader(),
  });
};

export const getInvoiceCertificates = async (id, invoiced = false, params = {}) => {
  return ky.get(
    urljoin(
      BASE_PATH,
      'cis',
      'invoices',
      String(id),
      `${invoiced ? '' : 'un'}invoiced-certificates`,
    ),
    {
      headers: withAuthorizationHeader(),
      searchParams: qs.stringify(params),
    },
  );
};

export const attachInvoiceCertificates = async (id, body) => {
  return ky.post(urljoin(BASE_PATH, 'cis', 'invoices', String(id), 'add-certificate'), {
    headers: withAuthorizationHeader(),
    body,
  });
};

export const detachInvoiceCertificates = async (body) => {
  return ky.post(urljoin(BASE_PATH, 'cis', 'invoices', 'remove-certificate'), {
    headers: withAuthorizationHeader(),
    body,
  });
};

export const getClientMAByCB = async (id) => {
  return ky.get(urljoin(BASE_PATH, 'cis', 'agreements', 'cb', String(id)), {
    headers: withAuthorizationHeader(),
  });
};

export const getClientMAByMA = async (id) => {
  return ky.get(urljoin(BASE_PATH, 'cis', 'agreements', 'ma', String(id)), {
    headers: withAuthorizationHeader(),
  });
};

export const getCblessMAs = async () => {
  return ky.get(urljoin(BASE_PATH, 'cis', 'certification-bodies', 'ma-options'), {
    headers: withAuthorizationHeader(),
  });
};

export const getCbCisUsers = async (id) => {
  return ky.get(
    urljoin(BASE_PATH, 'cis', 'certification-bodies', 'ma', String(id), 'cis-users'),
    {
      headers: withAuthorizationHeader(),
    },
  );
};

export const getAllowedLevelDomainsByCB = async (cbId) => {
  return ky.get(
    urljoin(BASE_PATH, 'cis', 'certification-bodies', String(cbId), 'allowed-level-domains'),
    {
      headers: withAuthorizationHeader(),
    },
  );
};

const handlePdfDownload = async (response, type, manualFilename = false) => {
  if (response.ok) {
    try {
      const blob = await response.blob();

      let fileName;
      if (manualFilename) {
        fileName = `${type}.pdf`;
      } else {
        const today = new Date();
        const formattedDate = `${today.getDate()}-${today.getMonth() + 1}-${today.getFullYear()}`;
        fileName = `cis-${type}-${formattedDate}.pdf`;
      }

      const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      console.log('PDF file downloaded successfully:', fileName);
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error('Error downloading PDF file:', error);
    }
  }
  return response;
};

const handleExcelDownload = async (response, type, manualFilename = false) => {
  if (response.ok) {
    try {
      const blob = await response.blob();

      let fileName;
      if (manualFilename) {
        fileName = `${type}.xlsx`;
      } else {
        const today = new Date();
        const formattedDate = `${today.getDate()}-${today.getMonth() + 1}-${today.getFullYear()}`;
        fileName = `cis-${type}-${formattedDate}.xlsx`;
      }

      const url = window.URL.createObjectURL(
        new Blob([blob], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }),
      );
      const link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  }
  return response;
};

export const fetchPdfCisReports = async (id) => {
  const response = await ky.get(urljoin(BASE_PATH, 'cis', 'reports', 'export', String(id)), {
    headers: withAuthorizationHeader(),
    Accept: 'application/pdf',
  });

  return await handlePdfDownload(response, 'cis-report');
};

export const exportCertificateHoldersToExcel = async (params = {}) => {
  const response = await ky.post(urljoin(BASE_PATH, 'cis', 'certificate-holders', 'export'), {
    headers: {
      ...withAuthorizationHeader(),
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    searchParams: qs.stringify(params),
  });
  return handleExcelDownload(response, 'certificate-holders');
};

export const exportCertificatesToExcel = async (params = {}) => {
  const response = await ky.post(urljoin(BASE_PATH, 'cis', 'certificates', 'export'), {
    headers: {
      ...withAuthorizationHeader(),
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    searchParams: qs.stringify(params),
  });
  return handleExcelDownload(response, 'certificates');
};

export const exportUsersToExcel = async (params = {}) => {
  const response = await ky.post(urljoin(BASE_PATH, 'user', 'export'), {
    headers: {
      ...withAuthorizationHeader(),
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    searchParams: qs.stringify(params),
  });
  return handleExcelDownload(response, 'users');
};

export const printInvoiceSummary = async (id) => {
  const response = await ky.get(
    urljoin(BASE_PATH, 'cis', 'invoices', String(id), 'print-summary'),
    {
      headers: {
        ...withAuthorizationHeader(),
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    },
  );
  return handleExcelDownload(response, 'invoice-summary-export');
};

export const downloadCertificateHoldersImportTemplate = async () => {
  const response = await ky.get(
    urljoin(BASE_PATH, 'cis', 'certificate-holders', 'import-template'),
    {
      headers: {
        ...withAuthorizationHeader(),
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    },
  );
  return handleExcelDownload(response, 'import-certificate-holders', true);
};

export const exportCertificatesReportToExcel = async (params) => {
  const response = await ky.get(urljoin(BASE_PATH, 'cis', 'certificates', 'report'), {
    headers: {
      ...withAuthorizationHeader(),
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    searchParams: params,
  });

  const suffix = params.year ? `-${params.year}` 
    : params.dateFrom || params.dateTo ? `-${params.dateFrom ?? 'begin'}-${params.dateTo ?? 'end'}` : 'all-time';

  return handleExcelDownload(response, `cis-certificates-report${suffix}`, true);
};

export const importData = async ({ payload }) => {
  return ky.post(urljoin(BASE_PATH, 'cis', 'certificate-holders', 'import'), {
    headers: withAuthorizationHeader(),
    body: payload,
  });
};

export const exportForecastReportToExcel = async (params) => {
  const response = await ky.get(urljoin(BASE_PATH, 'cis', 'forecasts', 'report'), {
    headers: {
      ...withAuthorizationHeader(),
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    searchParams: params,
  });
  return handleExcelDownload(response, 'forecast-report');
};

export const acceptCisImport = async (id) => {
  return ky.post(urljoin(BASE_PATH, 'cis', 'unknown-imports', 'accept', String(id)), {
    headers: withAuthorizationHeader(),
  });
};

export const rejectCisImport = async (id) => {
  return ky.post(urljoin(BASE_PATH, 'cis', 'unknown-imports', 'reject', String(id)), {
    headers: withAuthorizationHeader(),
  });
};

export const getSignatureOptions = async (params) => {
  return ky.get(urljoin(BASE_PATH, 'cis', 'signatures', 'options'), {
    headers: withAuthorizationHeader(),
    searchParams: params,
  });
};

export const toggleCertificationBodySuspended = async (id) => {
  return ky.post(urljoin(BASE_PATH, 'cis', 'certification-bodies', 'toggle', String(id)), {
    headers: withAuthorizationHeader(),
  });
};

export const verifyChangeRequest = async (id, params) => {
  return ky.post(urljoin(BASE_PATH, 'cis', 'change-requests', 'verify', String(id)), {
    headers: withAuthorizationHeader(),
    body: JSON.stringify(params),
  });
};

export const approveChangeRequest = async (id, params) => {
  return ky.post(urljoin(BASE_PATH, 'cis', 'change-requests', 'approve', String(id)), {
    headers: withAuthorizationHeader(),
    body: JSON.stringify(params),
  });
};

export const implementChangeRequest = async (id, params) => {
  return ky.post(urljoin(BASE_PATH, 'cis', 'change-requests', 'implement', String(id)), {
    headers: withAuthorizationHeader(),
    body: JSON.stringify(params),
  });
};

export const exportChangeRequestsToExcel = async (scope = 'ipma', params = {}) => {
  const segments = scope === 'ma'
    ? [BASE_PATH, 'cis', 'change-requests', 'ma', 'export']
    : [BASE_PATH, 'cis', 'change-requests', 'export'];

  const response = await ky.post(urljoin(...segments), {
    headers: {
      ...withAuthorizationHeader(),
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    searchParams: qs.stringify(params),
  });
  return handleExcelDownload(response, 'change-requests');
};